import React, { useEffect } from 'react';
import { CSSColorPicker, CSSColorPickerExpand, CSSColorPickerIcon, CSSColorPickerLabel } from './JRCInputColor.styles';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { JRCInputColorRawProps } from './JRCInputColorRawProps';

import { ColorPicker } from './ColorPicker';

import styled from 'styled-components';

export const CSSColorPickerWrapper = styled.div<{ expandPositionAbsolute?: boolean }>`
    padding: 16px 0 8px 0;
`;

export const JRCInputColorRaw = (props: JRCInputColorRawProps) => {
    const [expand, setExpand] = React.useState(false);
    const [color, setColor] = React.useState(props.initialValue ?? '#8F7CEA');

    useEffect(() => {
        if (props.disabled) {
            setExpand(false);
        }
    }, [props.disabled]);

    return (
        <>
            <CSSColorPicker
                onClick={() => {
                    if (!props.disabled) {
                        setExpand(!expand);
                    }
                }}
                type="button"
                aria-haspopup="true"
                aria-expanded={expand}
                data-testid="ColorPicker_expand"
                disabled={props.disabled}>
                <CSSColorPickerIcon>
                    <JRCIcon name={'icon-tint'} size={18} color={props.disabled ? 'transparent' : color} />
                </CSSColorPickerIcon>
                <CSSColorPickerLabel>{props.disabled ? '-' : color.toUpperCase()}</CSSColorPickerLabel>
                <CSSColorPickerExpand>
                    <JRCIcon color="grey2" name={!expand ? 'icon-angle-down' : 'icon-angle-up'} size={18} />
                </CSSColorPickerExpand>
            </CSSColorPicker>
            {expand ? (
                <CSSColorPickerWrapper>
                    <ColorPicker
                        initialColor={props.initialValue ?? '#8F7CEA'}
                        palettes={props.palettes}
                        width={340}
                        height={150}
                        onChange={(color, trigger) => {
                            setColor(color);
                            if (trigger) {
                                props.onChange(color);
                            }
                        }}
                    />
                </CSSColorPickerWrapper>
            ) : (
                <></>
            )}
        </>
    );
};
